import { render, staticRenderFns } from "./AiAssistantDrawer.vue?vue&type=template&id=23523ca0&scoped=true"
import script from "./AiAssistantDrawer.vue?vue&type=script&lang=ts"
export * from "./AiAssistantDrawer.vue?vue&type=script&lang=ts"
import style0 from "./AiAssistantDrawer.vue?vue&type=style&index=0&id=23523ca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23523ca0",
  null
  
)

export default component.exports